var React = require('react');

function DoubleQuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.653 34.451V17.975h-6.178v-1.782c0-5.455 2.06-8.757 6.178-9.908V.106C5.669 1.071.177 8.363.177 21.982v12.47h16.476zm24.715 0V17.975H35.19v-1.782c0-5.455 2.06-8.757 6.18-9.908V.106c-10.985.965-16.477 8.257-16.477 21.876v12.47h16.476z"}));
}

DoubleQuoteInline.defaultProps = {"viewBox":"0 0 42 35"};

module.exports = DoubleQuoteInline;

DoubleQuoteInline.default = DoubleQuoteInline;
